import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
//@ts-ignore
import styles from './recognition.module.css';

interface IRecognition  {
    logo: {
        file: {
            url: string;
        }
    }
    text: {
        content: Array<{
            content: Array<{
                value: string
            }>
        }>
    }
}
const useRecognitionQuery = (): Array<IRecognition> => {
    const data = useStaticQuery(graphql`
    query RecognitionQuery {
        allContentfulRecognition{
            nodes {
                logo {
                        file {
                            url
              }
          }
          text {
            text 
            content {
                        content {
                            value
              }
            }
          }
          
        }
      }
    }
    `);
    return data?.allContentfulRecognition?.nodes as Array<IRecognition>;

}

export const Recognition = () => {
    const recognitionData = useRecognitionQuery();
    // console.log({recognitionData});
    return (
        <section className={styles.recognitionContainer} id="about_us">
            <div className={styles.sectionTitle}>Recognition & Prizes</div>
            <div className={styles.recogCardBox}>
                {
                    recognitionData?.map((recog, _) => {
                        // console.log({recog});
                        return(
                        <div key={_} className={styles.recogCard}>
                            <div style={{height: "auto", width: 200}}>
                                <img src={recog?.logo?.file?.url}></img>
                            </div>
                            {recog.text.content.map(c => c.content.map(t => <p>{t.value}</p>))}
                        </div>
                        )
                    })
                }
            </div>
        </section>
    )
}